import TaskPaneAdapter from '../adapters/TaskPaneAdapter';
import { getAdapter } from '../adapters/AdapterManager';
import {
    terminateTaskPaneAddinCommand,
    getTaskPaneRunningInstanceByControlId,
    getTaskPaneType,
} from 'owa-addins-store';

export default function closeTaskPaneAddinCommandByControlId(controlId: string) {
    let runningTaskPane = getTaskPaneRunningInstanceByControlId(controlId);
    if (!runningTaskPane) {
        return;
    }

    const hostItemIndex = runningTaskPane.hostItemIndex;
    const taskPaneType = getTaskPaneType(controlId);
    terminateTaskPaneAddinCommand(taskPaneType);

    const adapter = getAdapter(hostItemIndex);
    if ((<TaskPaneAdapter>adapter).closeTaskPane) {
        (<TaskPaneAdapter>adapter).closeTaskPane();
    }
}
